import React from "react";
import { CalendarDays } from "lucide-react";

const DAYS = [["1", "Lun"], ["2", "Mar"], ["3", "Mer"], ["4", "Gio"], ["5", "Ven"], ["6", "Sab"], ["7", "Dom"]];
export const weekdaysParam = (value) => (value && value.length && value.length < 7 ? value.join(",") : undefined);

export function WeekdayFilter({ value, onChange, testid = "crm-weekday-filter" }) {
  const sel = value || [];
  const toggle = (d) => onChange(sel.includes(d) ? sel.filter((x) => x !== d) : [...sel, d].sort());
  const allOrNone = sel.length === 0 || sel.length === 7;
  return (
    <div className="flex items-center gap-1" data-testid={testid} title="Giorni della settimana inclusi (nessuno selezionato = tutti)">
      <CalendarDays className="h-3.5 w-3.5 text-zinc-500 mr-0.5" />
      {DAYS.map(([d, l]) => {
        const on = sel.includes(d);
        return (
          <button key={d} type="button" onClick={() => toggle(d)} data-testid={`${testid}-${d}`} aria-pressed={on}
            className={`h-8 px-2 rounded-md border text-[11px] font-semibold transition-colors ${on ? "bg-[color:var(--paprika)] border-[color:var(--paprika)] text-white" : allOrNone ? "border-zinc-800 text-zinc-300 hover:border-zinc-600" : "border-zinc-800 text-zinc-600 hover:text-zinc-300"} ${d === "7" ? "" : ""}`}>{l}</button>
        );
      })}
      {sel.length > 0 && <button type="button" onClick={() => onChange([])} data-testid={`${testid}-clear`} className="text-[11px] text-zinc-500 hover:text-zinc-200 ml-1 underline">tutti</button>}
    </div>
  );
}
